import HTML5Video from  './html5_video'
export default HTML5Video



// WEBPACK FOOTER //
// ./src/playbacks/html5_video/index.js